
import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Chip } from "@mui/material";

import api from "@/app/lib/api";
import { availableName } from "@/utils/functions";
import { Question } from "@/utils/types";

type Props = {
  quest: {question : string, send_notif : number, next_questions : number[] , response : string}[]; 
  setReponse: (response: string) => void;
  setQuestion: (data: { question: string; send_notif: boolean }) => void;
}; 

export const ChatBotSuggestions = ({ quest, setReponse, setQuestion }: Props) => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";

  const [selectedQuestions, setSelectedQuestions] = useState<Question[]>([]);

  // Fetch chatbot questions from the API
  const {
    data: questionsAndResponses,
    isSuccess,
  } = useQuery({
    queryKey: ["chatbotQuestions"],
    queryFn: async () => {
      const res = await api.chatBotQuestions.getAll();

      // Initialize with the first three questions if none are selected yet
      if (selectedQuestions.length === 0) {
        setSelectedQuestions([res[0], res[1], res[2]]);
      }

      return res;
    },
  });

  // Renders the suggestion chips
  return (
    <div>
      <div
        className="flex gap10"
        style={{ maxWidth: "90vw", overflowX: "auto" }}
      >
        {isSuccess &&
          Array.isArray(selectedQuestions) &&
          selectedQuestions.map((qust, index) => (
            <div key={index}>
              <Chip
                color="primary"
                variant="outlined"
                label={availableName(qust.question, currentLocale)}
                onClick={async () => {
                  // When a chip is clicked, set the question and response
                  setQuestion({
                    question: availableName(qust.question, currentLocale),
                    send_notif: qust.send_notif === 1,
                  });

                  setReponse(availableName(qust.response, currentLocale));

                  // Load the next set of suggested questions
                  const next = questionsAndResponses?.filter((q: Question) =>
                    (qust.next_questions as number[]).includes(q.id)
                  );
                  setSelectedQuestions(next);
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
};
